import {useEffect, useState} from 'react';

export const IsPWA = (props) => {
    const [isPWA, setIsPWA] = useState(false);

    useEffect(() => {
        const checkPWAStatus = () => {
            if (
                ('standalone' in window.navigator && window.navigator.standalone) ||
                window.matchMedia('(display-mode: standalone)').matches
            ) {
                setIsPWA(true);
            } else {
                setIsPWA(false);
            }
        };

        // Check PWA status on initial render
        checkPWAStatus();

        // Listen for changes in the display mode
        window.matchMedia('(display-mode: standalone)').addEventListener('change', checkPWAStatus);

        // Cleanup event listener on unmount
        return () => {
            window.matchMedia('(display-mode: standalone)').removeEventListener('change', checkPWAStatus);
        };
    }, []);

    return isPWA;
}